// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"W7-z","upvote":"X7-z","downvote":"Y7-z","numVotes":"Z7-z","votesDescription":"_7-z","report":"a8-z","voted":"b8-z","answerVoteBox":"c8-z","justReported":"d8-z"};